import { useApiQuery } from "app/modules/api-client";

import { useCommonAlertsQueryParams } from "../useCommonAlertsQueryParams";

export const useAlertCounts = () => {
    const params = useCommonAlertsQueryParams();

    return useApiQuery(
        {
            tag: "Alerts",
            methodName: "activationAlertsCountDetail",
            options: {
                refetchOnMount: true,
            },
        },
        params,
    );
};
